/**
 * Created by Ning Jiang on 10/24/2018.
 */

import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";

export class DeadwoodReelSymbolStateCreator extends ReelSymbolStateCreator {

    constructor() {
        super();
    }

    protected noWinStateCreator(symbol:StateReelSymbol, stateKey:string, stateConfig:ISymbolStateConfig):TimelineSprite | null {
        const stateAnimation:TimelineSprite | null = this.getBasicStateAnimation(symbol, stateKey, stateConfig);
        if(stateAnimation) {
            stateAnimation.tint = 0x555555;
        }
        return stateAnimation;
    }
}